import React, { useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import { settingsFunctions } from '../../../../../functions/settings';
import './ButtonSelector.css'

function ButtonSelector(props) {
    const { setButtonType } = props;
    const { createButtonOptions } = settingsFunctions;
    const [ selectOptions ] = useState(createButtonOptions());

    return (
        <InputGroup className='button-selector-input-group'>
            {selectOptions.length > 0 && 
                selectOptions.map((obj, i) => (
                    <button key={obj.ref + i} className='button-select-btn' onClick={() => setButtonType(obj)}>
                        <i className={`${obj.icon} fa-2x`}></i>
                        {obj.name}
                    </button>
                ))
            }
        </InputGroup>
    );
};

export default ButtonSelector;